import { ComponentKey } from "./process.constants";

export enum Operator {
  "IN" = "in",
  "EQUAL" = "eq",
  "NOT_EQUAL" = "nt",
  "GREATER_THAN" = "gt",
  "LESS_THAN" = "lt",
  "EXCEPT" = "except",
  "CONTAINS" = "contains"
}
/* eslint-disable @typescript-eslint/naming-convention */
// Since these cant be changed as these are system level enum mappings
export enum RuleType {
  // Process
  "WorkflowAccess" = "workflow__access_group_constraints",

  // Swimlane
  "StepGroupAccess" = "stepgroup__access_group_constraints",

  // Step
  "StepAccess" = "step__access_group_constraints",
  "Notification" = "step__notifications",
  "PDFGeneration" = "step__pdf_constraints",
  "StepAction" = "step__action_constraints_v2",
  "StepVisibility" = "step__constraints",
  "VersionNamingConstraints" = "version_naming_constraints_v2",

  // Field
  "RAG" = "status_constraints",
  "AttachmentInheritance" = "attachment_inheritance_constraints",
  "AttachmentInheritanceV2" = "attachment_inheritance_constraints_v2",
  "ChildProcessCreation" = "child_workflow_creation_constraints",
  "DataInheritance" = "inheritance_constraints_v2",
  "DataReduction" = "reduction_constraints",
  "IntegrationPolling" = "integration_polling_constraints",
  "IntegrationTrigger" = "integration_trigger_constraints",
  "RelatedProcessDataInheritance" = "related_workflow_field_constraints",
  "FieldVisibility" = "constraints",
  "RelatedWorkflowFileConstraintsV2" = "related_workflow_file_constraints_v2",
  "ReadOnlyFieldConstraints" = "read_only_field_constraints"
}

export enum RuleTypeToDBKey {
  // Process
  "WorkflowAccess" = "accessGroupConstraints",

  // Swimlane
  "StepGroupAccess" = "accessGroupConstraints",

  // Step
  "StepAccess" = "accessGroupConstraints",
  "Notification" = "notifications",
  "PDFGeneration" = "pdfConstraints",
  "StepAction" = "stepActionConstraints",
  "StepVisibility" = "visibilityConstraints",
  "VersionNamingConstraints" = "versionNamingConstraints",

  // Field
  "RAG" = "RAGConstraints",
  "AttachmentInheritance" = "attachmentInheritanceConstraints",
  "AttachmentInheritanceV2" = "attachmentInheritanceConstraintsV2",
  "ChildProcessCreation" = "childWorkflowCreationConstraintsRaw",
  "DataInheritance" = "dataInheritanceConstraints",
  "DataReduction" = "dataReductionConstraints",
  "IntegrationPolling" = "integrationPollingConstraints",
  "IntegrationTrigger" = "integrationTriggerConstraints",
  "RelatedProcessDataInheritance" = "relatedWorkflowFieldConstraints",
  "RelatedWorkflowFileConstraintsV2" = "relatedWorkflowFileConstraintsV2",
  "FieldVisibility" = "visibilityConstraints",
  "ReadOnlyFieldConstraints" = "readOnlyFieldConstraints"
}

export enum CompareType {
  "ANY" = "OR",
  "ALL" = "AND"
}

export const ComponentTypeToRuleTypeMap = {
  [ComponentKey.PROCESS]: [RuleTypeToDBKey.WorkflowAccess] as const,
  [ComponentKey.SWIMLANES]: [RuleTypeToDBKey.StepGroupAccess] as const,
  [ComponentKey.STEPS]: [
    RuleTypeToDBKey.StepAccess,
    RuleTypeToDBKey.Notification,
    RuleTypeToDBKey.PDFGeneration,
    RuleTypeToDBKey.StepAction,
    RuleTypeToDBKey.StepVisibility,
    RuleTypeToDBKey.VersionNamingConstraints
  ] as const,
  [ComponentKey.FIELDS]: [
    RuleTypeToDBKey.RAG,
    RuleTypeToDBKey.AttachmentInheritance,
    RuleTypeToDBKey.AttachmentInheritanceV2,
    RuleTypeToDBKey.ChildProcessCreation,
    RuleTypeToDBKey.DataInheritance,
    RuleTypeToDBKey.DataReduction,
    RuleTypeToDBKey.IntegrationPolling,
    RuleTypeToDBKey.IntegrationTrigger,
    RuleTypeToDBKey.RelatedProcessDataInheritance,
    RuleTypeToDBKey.RelatedWorkflowFileConstraintsV2,
    RuleTypeToDBKey.FieldVisibility,
    RuleTypeToDBKey.ReadOnlyFieldConstraints
  ] as const
};
